import React from 'react';

//import {Helmet} from "react-helmet";
import {postMessage,validateForm,getSettings,Head} from './../../helpers';
const FormTemplate = (props) =>{
    const form = props.form;
    return <div>{Object.keys(form).map((item)=>{
        if(item ==="datetime") return null;
        return <div className="formfield" key={item}>
            <p><strong>{form[item]}</strong></p>
            {(item==="item6")?
                <p><textarea maxLength="240" onChange={props.changeState.bind(this)} className="textarea" name={item} value={props.state.form[item] || ""}></textarea></p>:
                item!=="item2"? <p><input maxLength="100" onChange={props.changeState.bind(this)} type="text" className="input" name={item} value={props.state.form[item] || ""}/></p>:null
            }
            {item==="item2"? <div className="columns is-mobile">
               <div className="column"><input maxLength="3" onChange={props.changeState.bind(this)} type="text" className="input" name="phone1" value={props.state.form.phone1 || ""}/></div>
               <div className="column"><input maxLength="3" onChange={props.changeState.bind(this)} type="text" className="input" name="phone2" value={props.state.form.phone2 || ""}/></div>
               <div className="column"><input maxLength="4" onChange={props.changeState.bind(this)} type="text" className="input" name="phone3" value={props.state.form.phone3 || ""}/></div>
            </div>:null}
        </div>
    })}</div>;
}
const filterPhone = (phone)=>{
    const pho = phone.replace(/\D+/g, '');
    return pho;
}
const ContactUs = (props) =>{
    const page = props.page;
    const biz = getSettings("address",props.app.settings);
    const theme = getSettings("theme",props.app.settings);
    const site = props.app.settings.site;
    const form = page.items || {};
    const phone = biz("phone");
    const phonelink = "tel:1" + filterPhone(phone);
    const map = 'https://www.google.com/maps?q='+biz("address")+'&output=embed';
    const datetime    = window.moment.tz("America/New_York").format("MM-DD-YYYY hh:mm a").toString();
    const cellphone =   props.app.settings.pages.contact.hasOwnProperty("cellphone")? props.app.settings.pages.contact.phones : "0";
    console.log(site);
    return <div className="hero is-fullheight is-white">
            <div className="section">
                <div className="container">
                    <h2 className="title is-3">{Head.title(`${biz("bizname")} | ${page.name}`)}</h2>
                    <div className="columns">
                    <div className="column">
                            <div className="notification">
                                <iframe width="100%" title="business-map" style={{marginBottom:"30px",height:"280px"}} src={map}></iframe>             
                                <div className="spacer">
                                    <h2 className="title is-3">{biz("bizname")}</h2>
                                </div>
                                <div className="spacer">
                                    <p className="subtitle is-4">{biz("address")}</p>
                                </div>
                                <div className="spacer">
                                    <a href={phonelink} className={`button ${theme('themeColor')} is-large`}>{phone}</a>
                                </div>
                            </div>
                        </div>
                        {site.form===1? <div className="column">
                            <FormTemplate form={form} {...props}/>
                            <button onClick={(e)=>{
                                let postvalues = props.state.form || {};
                                    postvalues.datetime = datetime;
                                    postvalues.cellphone = "8456523344";
                                    validateForm(postvalues,form,function(status,error){
                                        if(status){
                                            if(typeof props.app.client ==="string"){
                                                postMessage(props.app.client, postvalues,function(res){
                                                    if(res){
                                                        alert("Message Sent!");
                                                        props.changeState("clear");
                                                    }
                                                });
                                            }else{
                                                alert("Error: username");
                                            }
                                        }else{
                                            alert(error);
                                        }
                                    });
                            }} className={`button ${theme('themeColor')} is-medium`}>Send message</button>
                        </div>:null}
                      
                    </div>
                </div>
            </div>
    </div>
}
export default ContactUs;
/*

*/ 


// WEBPACK FOOTER //
// ./src/components/themes/Contact.js